import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-footStats"
}

import NoData from '../NoData.vue';
    import type { IMatch } from '~src/interfaces';
    import type { IFootyStats, IPreviousMatchId, ITeam } from '~src/interfaces/footystats';
    import FootballTeam from '~src/components/foot_stats/FootballTeam.vue';
    import FinalScore from '~src/components/foot_stats/final_score/FinalScore.vue';
    import Performance from '~src/components/foot_stats/performance/Performance.vue';
    import H2HStatistics from '~src/components/foot_stats/h2h_statistics/H2HStatistics.vue';
    import GoalsScored from '~src/components/foot_stats/goals_scored/GoalsScored.vue';
    import GoalsOverUnder from '~src/components/foot_stats/goals_scored/GoalsOverUnder.vue';
    import BothTeamsScore from '~src/components/foot_stats/goals_scored/BothTeamsScore.vue';
    import TotalCornerKicks from '~src/components/foot_stats/corner/TotalCornerKicks.vue';
    import TeamCornerKick from '~src/components/foot_stats/corner/TeamCornerKick.vue';
    import WhoWillScore from '~src/components/foot_stats/who_will_score/WhoWillScore.vue';
    import Card from '~src/components/foot_stats/screens/Card.vue';
    import WhoIsFirstScoreVue from '~src/components/foot_stats/who_will_score/WhoIsFirstScore.vue';
    import PerformanceHalfTime from '~src/components/foot_stats/performance/PerformanceHalfTime.vue';
    import TheShotList from '~src/components/foot_stats/screens/TheShotList.vue';
    import OffsideMiscList from '~src/components/foot_stats/screens/OffsideMiscList.vue';
    import WhistleList from '~src/components/foot_stats/screens/WhistleList.vue';
    import { computed, onMounted, ref } from 'vue';
    import { getAllTeams, getMatchDetail } from '~src/services/FootystatsService';
    import { isObjectEmpty } from '~src/helpers';

    
const __default__ = {};

interface Props {
        match: IMatch;
        footyStats: IFootyStats
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FootStatsList',
  props: {
    match: {},
    footyStats: {}
  },
  setup(__props: any) {

    const props = __props

    const homeTeamInfo = ref<ITeam | null>(null);
    const awayTeamInfo = ref<ITeam | null>(null);
    const fivePreviousMatches = ref<IPreviousMatchId[] | []>([]);

    onMounted(() => {
        if (props.footyStats) {
            homeTeamInfo.value = props.footyStats.home_team_info;
            awayTeamInfo.value = props.footyStats.away_team_info;
            if(props.footyStats?.h2h?.previous_matches_results && props.footyStats?.h2h?.previous_matches_results){
                fivePreviousMatches.value =  props.footyStats.h2h.previous_matches_ids.slice(0, 5);
            }
        }
    });

    const isShow = computed<boolean>(() => {
        return isObjectEmpty(props.footyStats);
    })

return (_ctx: any,_cache: any) => {
  return (!isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(FootballTeam, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          fivePreviousMatches: fivePreviousMatches.value
        }, null, 8, ["match", "footyStats", "fivePreviousMatches"]),
        _createVNode(FinalScore, {
          match: _ctx.match,
          footyStats: _ctx.footyStats
        }, null, 8, ["match", "footyStats"]),
        _createVNode(Performance, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(H2HStatistics, {
          match: _ctx.match,
          footyStats: _ctx.footyStats
        }, null, 8, ["match", "footyStats"]),
        _createVNode(GoalsScored, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(GoalsScored, {
          match: _ctx.match,
          mode: "as-loss",
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(GoalsOverUnder, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(BothTeamsScore, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(TotalCornerKicks, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(TeamCornerKick, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(WhoWillScore, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(WhoWillScore, {
          match: _ctx.match,
          mode: "as-loss",
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(Card, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(WhoIsFirstScoreVue, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(PerformanceHalfTime, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(TheShotList, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(OffsideMiscList, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"]),
        _createVNode(WhistleList, {
          match: _ctx.match,
          footyStats: _ctx.footyStats,
          homeTeamInfo: homeTeamInfo.value,
          awayTeamInfo: awayTeamInfo.value
        }, null, 8, ["match", "footyStats", "homeTeamInfo", "awayTeamInfo"])
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})